// Speedometer photos are captured the moment the driver taps, which is often at a 4-6 AM pickup
// with no signal. The image has to survive until connectivity returns, so it is held as a Blob in
// IndexedDB (localStorage is string-only and far too small) and referenced from the queued event
// by id. Mirrors the shape of driverLocationQueue.
const DB_NAME = "iotripsDriverPhotos";
const STORE_NAME = "odometerPhotos";
const DB_VERSION = 1;

let dbPromise;

function db() {
  if (typeof window === "undefined" || !("indexedDB" in window)) {
    return Promise.reject(new Error("IndexedDB unavailable"));
  }
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        const store = database.createObjectStore(STORE_NAME, { keyPath: "photoId" });
        store.createIndex("scopeKey", "scopeKey", { unique: false });
      }
    };
  });
  return dbPromise;
}

async function store(mode = "readonly") {
  const database = await db();
  return database.transaction(STORE_NAME, mode).objectStore(STORE_NAME);
}

function requestPromise(request) {
  return new Promise((resolve, reject) => {
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
}

export function newPhotoId(scopeKey, eventType) {
  return `${scopeKey}:${eventType}:${Date.now()}:${Math.random().toString(36).slice(2, 10)}`;
}

export async function savePendingPhoto(scopeKey, photoId, blob) {
  const objectStore = await store("readwrite");
  await requestPromise(objectStore.put({ photoId, scopeKey, blob, savedAt: Date.now() }));
}

export async function readPendingPhoto(photoId) {
  const objectStore = await store();
  const row = await requestPromise(objectStore.get(photoId));
  return row?.blob || null;
}

export async function removePendingPhoto(photoId) {
  const objectStore = await store("readwrite");
  await requestPromise(objectStore.delete(photoId));
}
